"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    tray: {
        backgroundColor: theme.white1,
        boxShadow: theme.indigoShadow1,
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    handleWrapper: {
        zIndex: constants_1.TRAY_HANDLE_ZINDEX
    },
    trayTitleContainer: {
        flexShrink: 0,
        height: 70,
        width: '100%',
        padding: 10,
        display: 'flex',
        flexFlow: 'row-reverse nowrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.grey6}`,
        '&[data-is-collapsed=true]': {
            borderBottom: 'none'
        },
        '&[data-is-inverted=true]': {
            flexFlow: 'row nowrap'
        }
    },
    trayCollapseIcon: {
        flexShrink: 0,
        cursor: 'pointer',
        color: theme.grey3,
        transition: 'transform .25s, color .25s',
        '&:hover': {
            color: theme.grey1
        },
        '&[data-is-collapsed=true]': {
            transform: 'rotate(-180deg)'
        },
        '&[data-is-inverted=true]': {
            transform: 'rotate(-180deg)',
            '&[data-is-collapsed=true]': {
                transform: 'rotate(0deg)'
            }
        }
    },
    trayTitle: {
        fontSize: 18,
        lineHeight: '25px',
        marginRight: 10,
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: 600,
        '& strong': {
            color: theme.indigo3
        }
    },
    trayBody: {
        flexGrow: 1,
        overflow: 'hidden',
        display: 'flex',
        flexFlow: 'column nowrap',
        '&[data-is-hidden=true]': {
            visibility: 'hidden',
            height: 0,
            flexGrow: 0
        }
    },
    trayCollapsedTitleWrapper: {
        marginTop: -8,
        flexGrow: 1,
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        overflow: 'hidden'
    },
    trayCollapsedTitle: {
        fontSize: 18,
        lineHeight: '25px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: 600,
        writingMode: 'vertical-lr',
        '& strong': {
            color: theme.indigo3
        }
    },
    trayCloseIcon: {
        flexShrink: 0,
        padding: 10,
        cursor: 'pointer',
        color: theme.grey3,
        transition: 'color .25s',
        '&:hover': {
            color: theme.grey1
        }
    }
});
//# sourceMappingURL=tray.style.js.map